import { useMutation } from "@tanstack/react-query";
import type { SaveStorefrontConfigsReq } from "adl-gen/ferovinum/app/api";
import { useAppService } from "../../use-app-service";

export const useSaveStorefrontConfigs = () => {
  const service = useAppService();
  return useMutation({
    mutationFn: (configsToSave: SaveStorefrontConfigsReq) =>
      service.orgSaveStorefrontConfigForNominatedPurchasers(configsToSave),
  });
};
